import { useLocation, useNavigate, useRevalidator } from "react-router";
import { urlHome, urlLoadProduct } from "../../../urls";
import { Button } from "@repo/ui/components/button";
import { useForm } from "@repo/ui/hooks/use-form";
import { useAsync } from "@repo/ui/hooks/use-async";
import { productApi } from "@repo/api-client";
import { useCurrentPos } from "../../../hooks/use-current-pos";
import { GeneralError } from "@repo/ui/components/form/general-error";
import { useSendEvent } from "../../../hooks/use-send-event";
import { CheckCircle } from "lucide-react";
import { Title } from "../../../components/title";

function Resume() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { club } = useCurrentPos();
  const revalidator = useRevalidator();
  const sendEvent = useSendEvent();

  const { execute: onSubmit, error: apiErrors } = useAsync(async () => {
    await productApi.createProductPos(state);
    revalidator.revalidate();
    sendEvent("product-created", state);
    navigate(urlHome());
  });

  const { ref, errors: formErrors } = useForm({
    initialValues: {
      confirm: false,
    },
    onSubmit,
  });

  const category = club.productCategories.find(
    (category) => category.id === state?.categoryId
  );

  const errors = { ...formErrors, ...apiErrors };

  return (
    <div className="flex flex-col items-center justify-center gap-4 w-full py-4 flex-1">
      <Title>Resumen del producto a crear</Title>
      <div className="bg-white border p-4 rounded-lg shadow-md mt-6 w-full flex flex-col gap-4">
        <div className="flex flex-col gap-3 text-2xl!">
          <div className="flex items-center justify-between">
            <p className="text-gray-500">Producto</p>
            <p className="text-gray-800 font-medium">{state?.name}</p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-gray-500">Precio</p>
            <p className="text-gray-800 font-medium">${state?.price}</p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-gray-500">Código de barras</p>
            <p className="text-gray-800 font-medium">{state.sku}</p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-gray-500">Categoría</p>
            <p className="text-gray-800 font-medium">{category?.name}</p>
          </div>
        </div>
      </div>
      <form ref={ref} className="flex flex-col gap-4 w-full">
        <GeneralError errors={errors} />
        <Button type="submit" size="4xl" variant="pos">
          <CheckCircle className="size-6" />
          Confirmar
        </Button>
      </form>
    </div>
  );
}

export const route = {
  path: urlLoadProduct("resume"),
  element: <Resume />,
};
